




import DSlider from '../../index';
import Vue from 'vue';
import Component from 'vue-class-component';

Vue.use(DSlider);
@Component({
  name: 'Demo1'
})
export default class Demo1 extends Vue {
  // TODO
}
